import { useStaggeredAnimation } from '@/hooks/useScrollAnimation';

const testimonials = [
  {
    name: 'María Elena R.',
    role: 'Paciente de Pediatría',
    quote: 'La atención que recibió mi hijo fue excepcional. Los pediatras son muy pacientes y el personal de enfermería siempre atento. Nos sentimos en familia.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20smiling%20latina%20woman%20in%20her%2030s%20with%20warm%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20background%2C%20clean%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-1-vm&orientation=squarish',
    rating: 5,
  },
  {
    name: 'Carlos M.',
    role: 'Paciente de Medicina General',
    quote: 'Llevé a mi padre a una emergencia a las 2 de la mañana y nos atendieron de inmediato. La dedicación del equipo médico es admirable. Gracias Vitalmedic.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20smiling%20middle-aged%20latin%20american%20man%20with%20warm%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20background%2C%20clean%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-2-vm&orientation=squarish',
    rating: 5,
  },
  {
    name: 'Ana Lucía F.',
    role: 'Paciente de Ginecología',
    quote: 'Desde mi primer control prenatal hasta el parto, el equipo me brindó una atención cálida y profesional. Recomiendo Vitalmedic a todas las mujeres de Tarija.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20smiling%20latina%20woman%20in%20her%2020s%20with%20warm%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20warm%20background%2C%20clean%20editorial%20portrait%20photography&width=200&height=200&seq=avatar-3-vm&orientation=squarish',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  const { ref, isVisible, getDelay } = useStaggeredAnimation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-secondary-950 relative overflow-hidden">
      <div className="absolute inset-0 texture-dots-light opacity-25" />
      <div className="absolute top-0 left-1/4 w-80 h-80 rounded-full bg-primary-600/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto" ref={ref}>
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div className={`max-w-xl reveal ${isVisible ? 'is-in' : ''}`}>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-accent-500 uppercase mb-4">
              <span className="w-8 h-px bg-accent-500" />
              Testimonios
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-background-50 leading-[1.08]">
              Lo que dicen nuestros <span className="italic text-accent-500">pacientes</span>
            </h2>
          </div>
          <div className={`flex items-center gap-3 reveal ${isVisible ? 'is-in' : ''}`}>
            <div className="flex items-center gap-1 text-accent-500">
              {[0, 1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill text-lg" />
              ))}
            </div>
            <div className="text-background-200 text-sm">
              <span className="font-bold text-background-50">4.9</span> / 5 valoración media
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`relative rounded-3xl bg-background-50/[0.04] border border-background-50/10 p-7 md:p-8 backdrop-blur-sm hover:bg-background-50/[0.07] transition-colors duration-500 reveal ${isVisible ? 'is-in' : ''} ${i === 1 ? 'md:-mt-6' : ''}`}
              style={{ transitionDelay: getDelay(i) }}
            >
              <i className="ri-double-quotes-l text-4xl text-accent-500/60" />
              <p className="text-background-100 text-sm md:text-base leading-relaxed my-5">
                {t.quote}
              </p>
              <div className="flex items-center gap-3 pt-5 border-t border-background-50/10">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover object-top border-2 border-accent-500/40"
                />
                <div>
                  <p className="text-sm font-semibold text-background-50">{t.name}</p>
                  <p className="text-xs text-background-300">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}